import { Box, SxProps, Typography, styled } from '@mui/material';

const Frame = styled(Box)({
	backgroundColor: '#F1F1F1',
	padding: '1.5rem',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column',
});

const Title = styled(Typography)({
	marginTop: '0.5rem',
});

const Description = styled(Typography)({
	color: '#929292',
	fontSize: 'var(--font-size-small)',
});

export const DpBorderRefunds = ({ sx }: { sx: SxProps }) => (
	<Frame sx={sx}>
		<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 37.5 37.5">
			<g id="Grupo_41" data-name="Grupo 41" transform="translate(0)">
				<g id="Grupo_47" data-name="Grupo 47" transform="translate(10.775 9.475)">
					<g id="Grupo_46" data-name="Grupo 46" transform="translate(0 0)">
						<path
							id="Trazado_37"
							data-name="Trazado 37"
							d="M717.468-321.622a.753.753,0,0,0-.025-.183.687.687,0,0,0-.03-.072.788.788,0,0,0-.046-.11.672.672,0,0,0-.05-.065.749.749,0,0,0-.07-.091.749.749,0,0,0-.065-.051.74.74,0,0,0-.089-.069l0,0,0,0-7.215-4.082a.759.759,0,0,0-.748,0l-3.492,1.978h0l-3.721,2.1,0,0,0,0a.717.717,0,0,0-.087.067.727.727,0,0,0-.068.052.73.73,0,0,0-.072.093.691.691,0,0,0-.048.063.715.715,0,0,0-.05.119.594.594,0,0,0-.026.063.744.744,0,0,0-.024.177c0,.007,0,.014,0,.021v8.544a.76.76,0,0,0,.385.661l7.215,4.082a.755.755,0,0,0,.121.049c.02.007.038.019.059.024a.748.748,0,0,0,.194.026.761.761,0,0,0,.194-.025c.021-.005.039-.017.059-.024a.734.734,0,0,0,.121-.049l7.215-4.082a.76.76,0,0,0,.385-.661v-8.544C717.47-321.612,717.468-321.617,717.468-321.622Zm-7.973-3.195,5.673,3.21-1.952,1.105-5.673-3.21Zm-.76,14.534-5.7-3.223v-6.8l5.7,3.226Zm.76-8.111-5.673-3.213L706-322.838l5.673,3.21Zm6.456,4.888-5.7,3.223v-6.8l5.7-3.226Z"
							transform="translate(-701.521 326.448)"
							fill="#2C2C2C"
							stroke="#2C2C2C"
							stroke-width="0.5"
						/>
					</g>
				</g>
				<g id="Grupo_52" data-name="Grupo 52" transform="translate(0 0)">
					<g id="Grupo_49" data-name="Grupo 49">
						<g id="Grupo_48" data-name="Grupo 48">
							<path
								id="Trazado_38"
								data-name="Trazado 38"
								d="M630.346-415.838a1.563,1.563,0,0,0-1.562,1.563v1.3a18.461,18.461,0,0,0-12.2-4.558,18.707,18.707,0,0,0-18.652,18.719,1.563,1.563,0,0,0,1.563,1.563,1.563,1.563,0,0,0,1.563-1.563,15.578,15.578,0,0,1,15.527-15.594,15.369,15.369,0,0,1,10.065,3.718h-1.432a1.563,1.563,0,0,0-1.563,1.563,1.563,1.563,0,0,0,1.563,1.563h5.128a1.563,1.563,0,0,0,1.563-1.562v-5.15A1.563,1.563,0,0,0,630.346-415.838Z"
								transform="translate(-597.933 417.531)"
								fill="#2C2C2C"
							/>
						</g>
					</g>
					<g id="Grupo_51" data-name="Grupo 51" transform="translate(3.689 17.219)">
						<g id="Grupo_50" data-name="Grupo 50">
							<path
								id="Trazado_39"
								data-name="Trazado 39"
								d="M665.646-252a1.563,1.563,0,0,0-1.562,1.563,15.578,15.578,0,0,1-15.527,15.594,15.368,15.368,0,0,1-9.968-3.633h1.5a1.563,1.563,0,0,0,1.563-1.563,1.563,1.563,0,0,0-1.563-1.562h-5.129c-.014,0-.027,0-.04,0a1.534,1.534,0,0,0-.177.018c-.044.006-.087.01-.13.02a1.587,1.587,0,0,0-.153.048c-.047.016-.094.031-.14.051s-.084.044-.125.068-.1.056-.144.088c-.012.009-.025.013-.037.023s-.047.045-.072.067a1.493,1.493,0,0,0-.12.112,1.5,1.5,0,0,0-.1.116c-.031.04-.06.08-.087.122s-.051.089-.073.134a1.4,1.4,0,0,0-.062.137c-.018.048-.032.1-.045.147a1.464,1.464,0,0,0-.034.145,1.661,1.661,0,0,0-.017.167c0,.032-.009.063-.009.1v5.15a1.563,1.563,0,0,0,1.563,1.562,1.563,1.563,0,0,0,1.562-1.562v-1.242a18.469,18.469,0,0,0,12.034,4.412,18.707,18.707,0,0,0,18.652-18.719A1.563,1.563,0,0,0,665.646-252Z"
								transform="translate(-633.398 252)"
								fill="#2C2C2C"
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
		<Title>{'30 días para cambios y devoluciones'}</Title>
		<Description>{'sin complicaciones'}</Description>
	</Frame>
);
